import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
const steps = [{
  id: '01',
  title: 'Discover',
  description: 'We begin by understanding the product, founder story, audience, aspirations and market context. Listening properly, identifying the commercial opportunity, and creating shared clarity before any design decisions are made.',
  included: ['Discovery session', 'Founder & product deep dive', 'Market & competitor review', 'Key findings summary', 'Opportunity mapping']
}, {
  id: '02',
  title: 'Define',
  description: 'We define the strategic decisions that shape the brand — who it is for, what it needs to communicate, how it should be positioned, and what should make it feel distinct and worth buying.',
  included: ['Audience clarity', 'Positioning direction', 'Core messaging', 'Story development', 'Tone of voice principles', 'Naming direction support']
}, {
  id: '03',
  title: 'Design',
  description: 'We create the visual foundations for the brand so it can be presented with confidence and consistency. Strategy translated into a premium and usable identity system.',
  included: ['Visual direction', 'Logo exploration → one final route', 'Colour palette', 'Typography direction', 'Core brand assets', 'Launch-ready creative direction']
}, {
  id: '04',
  title: 'Deliver',
  description: 'We organise and hand over the work clearly so the brand can be used with confidence across launch materials, content and future rollout.',
  included: ['Final brand assets', 'Brand guidelines', 'Organised handover files', 'Practical rollout guidance']
}];
export function ApproachTimeline() {
  return <section id="approach" className="py-20 md:py-32 px-5 md:px-10 border-b border-rule/60" data-id="element-22">
      <div className="max-w-6xl mx-auto" data-id="element-23">
        <ScrollReveal data-id="element-24">
          <div className="mb-16 md:mb-20 max-w-3xl" data-id="element-25">
            <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-6 font-medium" data-id="element-26">
              — Approach
            </p>
            <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink font-light" data-id="element-27">
              A clear process designed to create{' '}
              <em className="italic text-gold" data-id="element-28">clarity</em> and build value.
            </h2>
          </div>
        </ScrollReveal>

        <div className="space-y-px" data-id="element-29">
          {steps.map((step, index) => <ScrollReveal key={step.id} delay={index * 0.08} data-id="element-30">
              <motion.article className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-12 border-t border-ink/80 hover:bg-paper/50 transition-colors duration-500 px-2" data-id="element-31">
                <div className="md:col-span-2 flex md:flex-col items-baseline md:items-start gap-4 md:gap-3" data-id="element-32">
                  <span className="font-serif text-3xl md:text-4xl text-gold italic font-light" data-id="element-33">
                    {step.id}
                  </span>
                  <h3 className="font-serif text-2xl md:text-3xl text-ink font-normal" data-id="element-34">
                    {step.title}
                  </h3>
                </div>

                <div className="md:col-span-6" data-id="element-35">
                  <p className="text-base md:text-lg text-ink-soft leading-relaxed font-light" data-id="element-36">
                    {step.description}
                  </p>
                </div>

                <div className="md:col-span-4" data-id="element-37">
                  <p className="text-[10px] uppercase tracking-[0.25em] text-ink-mute mb-4" data-id="element-38">
                    Included
                  </p>
                  <ul className="space-y-2" data-id="element-39">
                    {step.included.map((item, i) => <li key={i} className="text-sm md:text-base text-ink-soft flex gap-3 font-light" data-id="element-40">
                        <span className="text-gold" data-id="element-41">·</span>
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.article>
            </ScrollReveal>)}
          <div className="border-t border-ink/80" data-id="element-42" />
        </div>
      </div>
    </section>;
}